import { INITIAL_PCP_FILTER_STATE } from '@/store/redux/reducers/pages/pcp';

import { IParsedQuery } from '../types';

// create filter object from parsed query to be passed to redux
export const getUrlFilters = (parsedQuery: IParsedQuery) =>
  Object.keys(parsedQuery).reduce(
    (acc, currentKey) => ({
      ...acc,
      ...(currentKey in INITIAL_PCP_FILTER_STATE && {
        [currentKey]: parsedQuery[currentKey as keyof IParsedQuery],
      }),
    }),
    {}
  );
